// extracted by mini-css-extract-plugin
export default {"lds-hourglass":"style_lds-hourglass__qD2Lb","lds-hourglass-after":"style_lds-hourglass-after__zjy9v"};